import script from "./AdminIssueReportDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIssueReportDetailView.vue?vue&type=script&setup=true&lang=js"

import "./AdminIssueReportDetailView.vue?vue&type=style&index=0&id=7ec483e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec483e6"]])

export default __exports__